export enum ActivitySubType {
  OneOnOne = '1x1',
  TwoOnOne = '2x1',
  ThreeOnOne = '3x1',
  Group = 'Group',
  None = 'None'
}
